// extracted by mini-css-extract-plugin
export default {"stepper":"a706ce6ab860","narrowStepper":"c8f2e95abe3c"};